/**
 * MSW Override: Booking Payment 3DS Refused scenario
 *
 * The payment call answers 422 CORE-SUBSCRIPTION-BOOKING-PAYMENT-AUTHENTICATION-FAILED
 * with details[payment_authentication].reason = CHALLENGE_CANCELLED: the customer
 * abandoned (or the bank refused) the challenge before anything was paid.
 *
 * Enable by setting ENABLE_MSW=true and
 * NUXT_PUBLIC_MSW_OVERRIDES_BOOKING_PAYMENT_3DS_REFUSED=true in your .env,
 * then restart the dev server.
 */

import type { HttpHandler } from 'msw';
import { http, HttpResponse } from 'msw';
import { BFF_ENDPOINTS, toMSWPattern } from '@cvo/domain';

export function createBookingPayment3dsRefusedOverrides(baseUrl: string): HttpHandler[] {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.post(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.BOOKING_PAYMENTS)}`,
      () => {
        console.log('[MSW] booking payment 3ds refused: 422 CHALLENGE_CANCELLED');

        // Must match BOOKING_PAYMENT_AUTHENTICATION_FAILED_ERROR_CODE in app/constants/booking.ts.
        return HttpResponse.json(
          {
            code: 'CORE-SUBSCRIPTION-BOOKING-PAYMENT-AUTHENTICATION-FAILED',
            message: 'Payment authentication failed',
            source: 'core-subscriptions',
            details: [
              { name: 'payment_authentication', reason: 'CHALLENGE_CANCELLED' },
              { name: 'provider_error_code', reason: 'customer-cancel' },
            ],
          },
          { status: 422 },
        );
      },
    ),
  ];
}
